import { FilterDropdown } from '@ui';
import { useInfiniteOpoListQuery } from '@/queries/opo';
import { OpoOrganizationOrderByOption } from '@/api/apis/opo';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { NameByValue } from '@/types';

type OPOFilterDropdownProps = {
  selectedKeys: string[];
  onSelectedKeysChange: (value: string[]) => void;
  showResetButton?: boolean;
};

export const OPOFilterDropdown = ({ selectedKeys, onSelectedKeysChange, showResetButton }: OPOFilterDropdownProps) => {
  const {
    list: opoList,
    isLoading: isOpoLoading,
    hasNextPage: hasNextOpoPage,
    loadNextPage: loadNextOpoPage,
    setSearchValue: onOpoSearch,
  } = useAsyncSearchableList({
    query: useInfiniteOpoListQuery,
    defaultSortOrder: { orderBy: OpoOrganizationOrderByOption.Name, asc: true },
  });

  return (
    <FilterDropdown
      title="OPO"
      items={opoList as NameByValue<string>[]}
      selectedKeys={selectedKeys}
      mode="multiple"
      size="sm"
      hasNextPage={hasNextOpoPage}
      isLoading={isOpoLoading}
      loadNextPage={loadNextOpoPage}
      onSearchValue={onOpoSearch}
      onSelectedKeysChange={onSelectedKeysChange}
      showResetButton={showResetButton}
    />
  );
};
